import { ConfiguratedHotAlerts } from '../../components/Modals/AddSurveyModal/addSurveyInterface';
import apiFetch from '../apiFetch';
import generateHeaders from '../myHeaders';

export const buildHotAlertConfigPayload = (configuratedHotAlerts: ConfiguratedHotAlerts) => ({
    openDataQuestionId: configuratedHotAlerts.openedQuestion ?? null,
    firstnameQuestionId: configuratedHotAlerts.firstName ?? null,
    lastnameQuestionId: configuratedHotAlerts.lastName ?? null,
    phoneQuestionId: configuratedHotAlerts.phone ?? null,
    emailQuestionId: configuratedHotAlerts.mail ?? null,
    satisfaction: configuratedHotAlerts.satisfaction ?? null,
    listingQuestionVariable: configuratedHotAlerts.additionalQuestion ?? [],
    detailQuestionVariableId: configuratedHotAlerts.detailQuestions ?? [],
    status: (configuratedHotAlerts.statuses ?? []).map((s) => ({
        id: s.id ?? null,
        label: s.label,
        isDefault: s.isDefault,
        isFinal: s.isFinal,
        color: s.colors,
    })),
});

const createHotAlertConfig = (
    surveyId: number,
    configuratedHotAlerts: ConfiguratedHotAlerts,
    selectedSchema: string,
): Promise<unknown> => apiFetch(
    `${process.env.REACT_APP_API_URL}/survey/${surveyId}/hot_alert_config/`,
    { method: 'POST', headers: generateHeaders(selectedSchema), body: JSON.stringify(buildHotAlertConfigPayload(configuratedHotAlerts)) },
);

export default createHotAlertConfig;
